import React from "react";
import { object } from "prop-types";
// eslint-disable-next-line import/no-cycle
import { CompareTableModal } from "./CompareTableModal";

const CompareTableModalConnector = ({ data }) => (
	<CompareTableModal header={data?.headers} rows={data?.rows} title={data?.title}>
		{data?.trigger}
	</CompareTableModal>
);

CompareTableModalConnector.propTypes = {
	data: object.isRequired,
};

export default CompareTableModalConnector;
export { CompareTableModalConnector };
